import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LOADING_STATUSES } from "@constants";
import { dashboardService } from "@services/dashboardService";

export const fetchDashboardOverview = createAsyncThunk("dashboard/fetchOverview", async (_, { getState }) => {
  return await dashboardService.getOverview(getState().filters);
});
export const fetchJourney = createAsyncThunk("dashboard/fetchJourney", async (_, { getState }) => {
  return await dashboardService.getJourney(getState().filters);
});
export const fetchDrivers = createAsyncThunk("dashboard/fetchDrivers", async (_, { getState }) => {
  return await dashboardService.getDrivers(getState().filters);
});
export const fetchVerbatins = createAsyncThunk("dashboard/fetchVerbatins", async (_, { getState }) => {
  return await dashboardService.getVerbatins(getState().filters);
});
export const fetchTrends = createAsyncThunk("dashboard/fetchTrends", async (_, { getState }) => {
  return await dashboardService.getTrends(getState().filters);
});
export const fetchSegmentation = createAsyncThunk("dashboard/fetchSegmentation", async (_, { getState }) => {
  return await dashboardService.getSegmentation(getState().filters);
});
export const fetchBenchmarking = createAsyncThunk("dashboard/fetchBenchmarking", async (_, { getState }) => {
  return await dashboardService.getBenchmarking(getState().filters);
});
export const fetchActionPlan = createAsyncThunk("dashboard/fetchActionPlan", async (_, { getState }) => {
  return await dashboardService.getActionPlan(getState().filters);
});
export const fetchCooperacao = createAsyncThunk("dashboard/fetchCooperacao", async () => {
  return await dashboardService.getCooperacao();
});

const addAsyncCases = (builder, thunk, key) => {
  builder
    .addCase(thunk.pending, (state) => {
      state[key].status = LOADING_STATUSES.LOADING;
      state[key].error = null;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state[key].status = LOADING_STATUSES.SUCCEEDED;
      state[key].data = action.payload;
    })
    .addCase(thunk.rejected, (state, action) => {
      state[key].status = LOADING_STATUSES.FAILED;
      state[key].error = action.error.message || "Falha ao carregar dados";
    });
};

const emptySection = () => ({ data: null, status: LOADING_STATUSES.IDLE, error: null });

const initialState = {
  overview: emptySection(),
  journey: emptySection(),
  drivers: emptySection(),
  verbatins: emptySection(),
  trends: emptySection(),
  segmentation: emptySection(),
  benchmarking: emptySection(),
  actionPlan: emptySection(),
  cooperacao: emptySection(),
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: { clearDashboard: () => initialState },
  extraReducers: (builder) => {
    addAsyncCases(builder, fetchDashboardOverview, "overview");
    addAsyncCases(builder, fetchJourney, "journey");
    addAsyncCases(builder, fetchDrivers, "drivers");
    addAsyncCases(builder, fetchVerbatins, "verbatins");
    addAsyncCases(builder, fetchTrends, "trends");
    addAsyncCases(builder, fetchSegmentation, "segmentation");
    addAsyncCases(builder, fetchBenchmarking, "benchmarking");
    addAsyncCases(builder, fetchActionPlan, "actionPlan");
    addAsyncCases(builder, fetchCooperacao, "cooperacao");
  },
});

export const { clearDashboard } = dashboardSlice.actions;
export const selectOverview = (state) => state.dashboard.overview;
export const selectJourney = (state) => state.dashboard.journey;
export const selectDrivers = (state) => state.dashboard.drivers;
export const selectVerbatins = (state) => state.dashboard.verbatins;
export const selectTrends = (state) => state.dashboard.trends;
export const selectSegmentation = (state) => state.dashboard.segmentation;
export const selectBenchmarking = (state) => state.dashboard.benchmarking;
export const selectActionPlan = (state) => state.dashboard.actionPlan;
export const selectCooperacao = (state) => state.dashboard.cooperacao;
export default dashboardSlice.reducer;
